import React from 'react';
import type { DriverPassSummary } from '../../../utils/driverPassSummaryUtils';
import {
  DRIVER_PASS_SUMMARY_SHORT_LABELS,
  getPassSummaryTooltip,
} from '../../../utils/driverPassSummaryUtils';
import './DriverPassSummaryBadges.css';

type Props = {
  summary?: DriverPassSummary;
};

const PASS_ORDER = ['el_abra', 'dmh', 'dgm'] as const;

const DriverPassSummaryBadges: React.FC<Props> = ({ summary }) => {
  if (!summary) {
    return <span className="driver-pass-badges driver-pass-badges--empty">—</span>;
  }

  const activePasses = PASS_ORDER.filter((passType) => summary[passType]?.enabled);

  if (activePasses.length === 0) {
    return <span className="driver-pass-badges driver-pass-badges--none">Sin pases</span>;
  }

  return (
    <div className="driver-pass-badges">
      {activePasses.map((passType) => {
        const item = summary[passType];
        return (
          <span
            key={passType}
            className="driver-pass-tag driver-pass-tag--on"
            title={getPassSummaryTooltip(item)}
          >
            {DRIVER_PASS_SUMMARY_SHORT_LABELS[passType]}
          </span>
        );
      })}
    </div>
  );
};

export default DriverPassSummaryBadges;
